import React, { useState } from 'react';
import { Phone } from 'lucide-react';
import { faqs, companyInfo } from '../utils/mockData';

const FAQ = () => {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section
        className="relative bg-cover bg-center py-14"
        style={{
          backgroundImage: 'linear-gradient(rgba(0, 71, 171, 0.9), rgba(0, 71, 171, 0.9)), url(https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1200)',
        }}
      >
        <div className="container mx-auto px-4 text-center text-white">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">Frequently Asked Questions</h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto">Find answers to common questions about insurance coverage and our services</p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-10">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-brand-blue mb-6 text-center">Have Questions? We Have Answers.</h2>
              <p className="text-base text-gray-700 text-center">
                Below are answers to some of the most common questions we receive. If you don't see your
                question here, feel free to contact us directly.
              </p>
            </div>

            <div className="space-y-4">
              {faqs.map((faq) => (
                <div key={faq.id} className="bg-white rounded-lg shadow-md overflow-hidden">
                  <button
                    onClick={() => setOpenFaq(openFaq === faq.id ? null : faq.id)}
                    className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition"
                    data-testid={`faq-toggle-${faq.id}`}
                  >
                    <span className="font-semibold text-brand-blue pr-4">{faq.question}</span>
                    <svg
                      className={`w-5 h-5 text-brand-orange transition-transform flex-shrink-0 ${openFaq === faq.id ? 'rotate-180' : ''}`}
                      fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {openFaq === faq.id && (
                    <div className="px-6 pb-4 text-gray-700 leading-relaxed border-t border-gray-100 pt-4">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="py-10 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-brand-blue mb-6">Still Have Questions?</h2>
          <p className="text-base text-gray-700 mb-8 max-w-2xl mx-auto">
            Our licensed agents at Purposefully Covered Insurance Group are here to help. Contact us today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="bg-brand-blue text-white px-8 py-3 rounded-md hover:bg-brand-orange transition font-semibold"
              data-testid="faq-contact-btn"
            >
              Contact Us
            </a>
            <a
              href={`tel:${companyInfo.phoneRaw}`}
              className="bg-brand-orange text-white px-8 py-3 rounded-md hover:bg-brand-orange-light transition font-semibold flex items-center justify-center gap-2"
              data-testid="faq-call-btn"
            >
              <Phone size={18} /> Call {companyInfo.phone}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
